"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _traffic = require("../traffic");
const useIdempotentImpression = (impressionId, properties = {}) => {
  (0, _react.useEffect)(() => {
    (0, _traffic.logEvent)({
      eid: impressionId,
      type: 'impression',
      properties
    });
  }, [impressionId]);
};
var _default = exports.default = useIdempotentImpression;